import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "balances-list-exchange-wrapper" }

import { throttle } from 'lodash/fp';
import { computed, ref, watch, type PropType } from 'vue';
import { useRouter } from 'vue-router';

import { authService } from '@exchange/libs/auth/service/src';
import { balanceService, filterBySearchAndSortByPortfolioSize } from '@exchange/libs/balances/service/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { marketService } from '@exchange/libs/market/service/src';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { currencyService } from '@exchange/libs/utils/currency/src';

import BalancesListExchangeDesktop from './BalancesListExchangeDesktop.vue';
import BalancesListExchangeMobile from './BalancesListExchangeMobile.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BalancesListExchange',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  historySource: { type: Object as PropType<HistoryDataSource>, required: true },
},
  setup(__props) {



const { isXS } = useMQBreakpoints();
const router = useRouter();

const search = ref<string>();
const { balanceSnapshotReceived } = balanceService;
const { getCurrencyName } = currencyService;
const { marketDataLoading } = marketService;

const balanceSource = computed(() => balanceService.list.value);

const getSortedBalanceList = () => filterBySearchAndSortByPortfolioSize(balanceSource.value, search.value, getCurrencyName);

const sortedList = ref(getSortedBalanceList());
const updateDebouncedSortedList = () => {
  sortedList.value = getSortedBalanceList();
};

watch(balanceSource, throttle(5_000, updateDebouncedSortedList));

const balanceLoadingUntil = computed(() => {
  if (!authService.hasBeenAuthenticated) {
    return false;
  }

  return !balanceSnapshotReceived.value;
});

watch([balanceLoadingUntil, marketDataLoading], ([bl, md]) => {
  if (!bl || !md) {
    updateDebouncedSortedList();
  }
});

const handleDeposit = (currencyCode?: string) => {
  router.push({ hash: '#Deposit', query: { currency: currencyCode } });
};

const handleTransfer = (currencyCode: string) => {
  const query = {
    currency: currencyCode,
    destination: CONSTANTS.INSTANT_TRADE_ACCOUNT_NAME,
    source: CONSTANTS.MAIN_SUBACCOUNT_NAME,
  };
  router.push({ hash: '#Transfer', query });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isXS))
      ? (_openBlock(), _createBlock(BalancesListExchangeDesktop, {
          key: 0,
          "authenticated-user": __props.authenticatedUser,
          "history-source": __props.historySource,
          "sorted-list": sortedList.value,
          onDeposit: handleDeposit,
          onTransfer: handleTransfer
        }, null, 8, ["authenticated-user", "history-source", "sorted-list"]))
      : (_openBlock(), _createBlock(BalancesListExchangeMobile, {
          key: 1,
          "authenticated-user": __props.authenticatedUser,
          "history-source": __props.historySource,
          "sorted-list": sortedList.value,
          onDeposit: handleDeposit,
          onTransfer: handleTransfer
        }, null, 8, ["authenticated-user", "history-source", "sorted-list"]))
  ]))
}
}

})